module.exports = (count) => {

  return [...Array(count).keys()]

}



// WEBPACK FOOTER //
// ../node_modules/berries/lib/times.js